"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const Density_1 = require("@becrop/components/Toolkit/Common/models/Density");
const Mwm_1 = __importDefault(require("./Mwm"));
const Genus_1 = __importDefault(require("./Genus"));
class AbundanceDensity {
    constructor(clusters) {
        this.clusters = clusters;
    }
    async genus_mwms() {
        const cluster_payload = this.clusters.toPayload();
        const data = {
            clusters: cluster_payload,
        };
        const response = await axios_1.default.post('/toolkit/wbp_abundances/genus_mwm_lists', data);
        const genus = response.data.genus.map((raw) => new Genus_1.default(raw)).sort((a, b) => a.genus.localeCompare(b.genus));
        const species = response.data.species.map((raw) => new Mwm_1.default(raw)).sort((a, b) => {
            const compareG = a.genus.localeCompare(b.genus);
            const compareS = a.species.localeCompare(b.species);
            return compareG || compareS;
        });
        return [genus, species];
    }
    async compare_genus(genus) {
        const cluster_payload = this.clusters.toPayload();
        const data = {
            clusters: cluster_payload,
            genus: genus.genus,
        };
        const response = await axios_1.default.post('/toolkit/wbp_abundances/compare_genus', data);
        return this.process_response(response);
    }
    async compare_species(mwm) {
        const cluster_payload = this.clusters.toPayload();
        const data = {
            clusters: cluster_payload,
            gs_id: mwm.id,
        };
        const response = await axios_1.default.post('/toolkit/wbp_abundances/compare_species', data);
        return this.process_response(response);
    }
    process_response(response) {
        const results = [];
        response.data.forEach((raw_density, i) => {
            // Ignore empty clusters
            if (!raw_density)
                return;
            // Create the density result
            results.push(new Density_1.DensityResult(this.clusters.all()[i], raw_density));
        });
        return results;
    }
}
exports.default = AbundanceDensity;
